import { Icon } from '@/modules/Icon';
import { ColorClasses } from '@/shared/types/stepper';
import { StepStatus } from '@/shared/types/types';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

interface StepIconProps {
  stepIndex: number;
  status: StepStatus;
  colorClasses: ColorClasses;
  className?: string;
  classNameNumber?: string;
}

/**
 * StepIcon - Indicador circular del paso
 * Número pendiente: color vía `colorClasses.text`; tipografía heading H3 con clases atómicas (`ui-text-heading-h3`, `ui-font-heading-h3`, `ui-leading-heading-h3`, `ui-tracking-heading-h3`).
 */
export const StepIcon = ({
  stepIndex,
  status,
  colorClasses,
  className = '',
  classNameNumber = '',
}: StepIconProps) => {
  const baseClasses =
    'ui-min-w-[38px] ui-min-h-[38px] ui-max-w-[38px] ui-max-h-[38px] ui-rounded-control-pill ui-flex ui-items-center ui-justify-center ui-border-3';

  const numberSpanClasses =
    `ui-text-heading-h3 ui-font-heading-h3 ui-leading-heading-h3 ui-tracking-heading-h3 ${classNameNumber}`.trim();

  if (status === 'completed') {
    return (
      <div className={`${baseClasses} ${colorClasses.primary} ${className}`}>
        <Icon name={faCheck} color="white" />
      </div>
    );
  }

  if (status === 'active') {
    return (
      <div
        className={`${baseClasses} ${colorClasses.primary.split(' ')[0]} ${className} ${colorClasses.secondary}`}
      >
        <div className={'ui-h-[14px] ui-w-[14px] ui-rounded-control-pill ui-bg-fill'}></div>
      </div>
    );
  }

  if (status === 'pending') {
    return (
      <div className={`${baseClasses} ui-bg-fill ${colorClasses.secondary} ${className}`}>
        <span className={`${colorClasses.text} ${numberSpanClasses}`}>{stepIndex + 1}</span>
      </div>
    );
  }

  return null;
};
